import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Printer, Calendar } from 'lucide-react';
export function ProductSection() {
  const features = [{
    icon: FileText,
    title: '3:00 AM Reset (PDF Kit Express)',
    desc: 'La guía completa con el protocolo Doble-Ruta 3x3.'
  }, {
    icon: Printer,
    title: "Tarjeta imprimible 'Modo 3:00 AM'",
    desc: '1 página para tener en tu mesa de noche. Tu guion de emergencia.',
    highlight: true
  }, {
    icon: Calendar,
    title: 'Tracker 7 Noches',
    desc: 'Para encontrar tu patrón real y quedarte con lo que funciona.'
  }];
  return <section className="w-full bg-[#15202B] py-24 px-6" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        {/* Star Feature Highlight */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-gradient-to-br from-[#E8614D] to-[#C0402C] rounded-2xl p-8 md:p-12 text-center mb-16 shadow-2xl shadow-[#E8614D]/20 relative overflow-hidden" data-id="element-118">
          <div className="relative z-10" data-id="element-119">
            <h3 className="text-[#1B2838] font-bold text-2xl md:text-3xl mb-4 font-sans" data-id="element-120">
              Lo más valioso: La Tarjeta Imprimible.
            </h3>
            <p className="text-[#F5E6D0] text-lg md:text-xl font-serif leading-relaxed max-w-2xl mx-auto" data-id="element-121">
              "Porque cuando estás medio dormida no quieres leer un libro.
              Quieres ver una hoja y pensar: Ok. Paso 1. Paso 2. Paso 3."
            </p>
          </div>

          {/* Decorative circles */}
          <div className="absolute top-0 left-0 w-64 h-64 bg-white/10 rounded-full -translate-x-1/2 -translate-y-1/2 blur-2xl" data-id="element-122" />
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-black/10 rounded-full translate-x-1/2 translate-y-1/2 blur-2xl" data-id="element-123" />
        </motion.div>

        <div className="text-center mb-12" data-id="element-124">
          <h2 className="text-3xl font-bold text-[#F5E6D0] mb-2 font-sans" data-id="element-125">
            Lo que recibes al comprar:
          </h2>
          <div className="w-16 h-1 bg-[#E8614D] mx-auto rounded-full" data-id="element-126" />
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-127">
          {features.map((feature, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15,
          duration: 0.6
        }} className={`bg-[#0F1923] p-6 rounded-xl border ${feature.highlight ? 'border-[#E8614D] ring-1 ring-[#E8614D]/30' : 'border-[#B8A99A]/10'} flex flex-col items-center text-center h-full`} data-id="element-128">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-4 ${feature.highlight ? 'bg-[#E8614D] text-[#1B2838]' : 'bg-[#1B2838] text-[#B8A99A]'}`} data-id="element-129">
                <feature.icon className="w-6 h-6" data-id="element-130" />
              </div>
              <h4 className={`font-bold text-lg mb-3 ${feature.highlight ? 'text-[#E8614D]' : 'text-[#F5E6D0]'}`} data-id="element-131">
                {"Tarjeta imprimible 'Modo 3:00 AM':"}
              </h4>
              <p className="text-[#B8A99A] text-sm leading-relaxed" data-id="element-132">
                {feature.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}